module.exports = __webpack_public_path__ + "img/goblin-f-70.dfab0c34.gif";